<script>
import { mapActions, mapGetters } from 'vuex'
import logger from '@/logger/index'

export default {

  props: {
    content: {
      type: Array,
      default: () => [],
    },

    titles: {
      type: Object,
      default: () => ({}),
    },

    visibleCheck: {
      type: Boolean,
      default: false,
    },

    filter: {
      type: String,
      default: null,
    },

    successField: {
      type: String,
      default: 'PERCENTUAL_SUCESSO',
    },

    hiddenFields: {
      type: Array,
      default: () => ['PERCENTUAL_SUCESSO'],
    },

    scrollPosition: {
      type: Number,
      default: 0,
    },
  },

  data () {
    return {
      selected: [],
      selectAll: false,
      withoutStock: false,
    }
  },
  computed: {
    ...mapGetters('orders', ['orders']),
    ...mapGetters('products', ['getSelectedParts', 'getPartProducts']),
    ...mapGetters('userPermissions', ['getFavoriteCompany', 'getBlockSale']),

    filteredData () { // NOTE: Filtra e retorna apenas os dados que serão mostrados na tabela
      let fields = Object.keys(this.titles)
      let filteredData = []
      this.content.map((item) => {
        let filteredItem = {}
        fields.forEach(field => {
          filteredItem[field] = item[field]
        })
        filteredData.push(filteredItem)
      })

      return filteredData
    },

    selectProduct () {
      return this.selected
    },
  },
  filters: {
    formatCode (value) {
      value = value.toString().split('.0')
      return value[0]
    },
  },

  watch: {
    selected: {
      handler (newVal) {
        this.setSelectedPartsProductsArray(newVal)
      },
      deep: true,
    },

    scrollPosition: {
      handler (newVal) {
        if (newVal > 0) {
          this.$nextTick(() => {
            const container = this.$refs.tableContainer
            if (container) {
              container.scrollTop = newVal
            }
          })
        }
      },
      immediate: false,
    },

    content: {
      handler () {
        // Quando o conteúdo muda, restaura o scroll após o DOM atualizar
        this.$nextTick(() => {
          if (this.scrollPosition > 0) {
            const container = this.$refs.tableContainer
            if (container) {
              container.scrollTop = this.scrollPosition
            }
          }
        })
      },
    },
  },

  mounted () {
    // Restaura a posição do scroll quando o componente é montado
    if (this.scrollPosition > 0) {
      this.$nextTick(() => {
        const container = this.$refs.tableContainer
        if (container) {
          container.scrollTop = this.scrollPosition
        }
      })
    }
  },

  methods: {
    ...mapActions(['setFeedback']),
    ...mapActions('products', ['addSelectedParts', 'setSelectedPartsProductsArray']),

    handleScroll (event) {
      const scrollTop = event.target.scrollTop
      this.$emit('table-scroll', scrollTop)
    },

    isObjectNullOrEmpty (obj) {
      return obj === null || Object.keys(obj).length === 0
    },

    selectedRow (item) {
      // logger.debug('item: ', item)
      if (this.filter === 'selectedParts') {
        return this.partProducts(item)
      }
      this.$emit('returnRow', item)
    },

    partProducts (item) {
      if (!this.isObjectNullOrEmpty(this.getSelectedParts)) {
        return this.$emit('closeTable', item)
      }
      this.addSelectedParts(item) // Adiciona no state selectedParts o código do conjunto
      this.cleanSelection()

      logger.debug('withoutStock: ', this.withoutStock)
      this.$emit('newTable')
    },

    cleanSelection () {
      this.selected = []
      this.selectAll = false
      this.withoutStock = false
    },

    selectAllProductTable () {
      this.selected = []

      if (this.withoutStock && !this.selectAll) {
        for (const prod of this.getSelectedParts.products) {
          //  Se não há estoque definido (prod.stock vazio ou indefinido),
          //    deixa selecionar e depois será barrado no modal-confirmation
          if (!Array.isArray(prod.stock) || prod.stock.length === 0) {
            this.selected.push(prod.product_id)
            continue
          }
          // pega a quantidade requisitada
          const stockSet = this.getPartProducts
            .find(item => item.product_id === prod.product_id)
            ?.quantity ?? 0

          // estoque do produto
          const stocks = Array.isArray(prod.stock) ? prod.stock : []

          // total de estoque em todo o estado
          const totalStock = stocks.reduce((sum, s) => sum + (s.quantity || 0), 0)

          // estoque preferencial
          const prefStock = stocks
            .find(s => s.company_id === this.getFavoriteCompany)
            ?.quantity ?? 0

          // lógica de bloqueio = 1 (sem bloqueio preferencial)
          if (this.getBlockSale !== 2 && totalStock >= stockSet) {
            this.selected.push(prod.product_id)

            // lógica de bloqueio = 2 (só no preferencial)
          } else if (this.getBlockSale === 2 && prefStock >= stockSet) {
            this.selected.push(prod.product_id)
          }
        }
        return
      }
      if (!this.selectAll) {
        for (const row of this.filteredData) {
          this.selected.push(row.product_id)
        }
      }
    },

    validateStock (stockId) {
      if (!stockId || this.getBlockSale === 0) {
        return false
      }
      // Verifica se possui estoque do produto  do conjunto de peças selecionado
      if (stockId) {
        const product = this.getSelectedParts?.products.find(product => product.product_id === stockId)

        if (this.getBlockSale === 2) {
          if (product && product.stock) {
            const totalStock = product.stock.find(stock => stock.company_id === this.getFavoriteCompany).quantity
            // logger.debug('product: ', product.product_id, '| totalStock: ', totalStock)
            const stockSet = this.getPartProducts.find(item => item.product_id === product.product_id).quantity
            // logger.debug('stockSet: ', stockSet)
            const result = totalStock < stockSet
            // logger.debug('result: ', result)
            if (result === true) { this.withoutStock = true }
            return result
          }
        } else if (this.getBlockSale === 1) {
          if (product && product.stock) {
            const totalStock = product.stock.reduce((total, stock) => total + stock.quantity, 0)
            // logger.debug('product: ', product.product_id, '| totalStock: ', totalStock)
            const stockSet = this.getPartProducts.find(item => item.product_id === product.product_id).quantity
            // logger.debug('stockSet: ', stockSet)
            const result = totalStock < stockSet
            // logger.debug('result: ', result)
            if (result === true) { this.withoutStock = true }
            return result
          }
        }
      }
      return false
    },

    getClass (index) {
      return index === 'quantity'
    },

    getSuccessClass (item) {
      const percentual = item[this.successField]
      if (percentual < 0.5) return 'success-low'
      if (percentual < 1) return 'success-medium'
      if (percentual === 1) return 'success-high'
      return ''
    },

  },

}
</script>

<template>
  <div ref="tableContainer" class="table-responsive" :class="$classes['div-table']" @scroll="handleScroll">
    <table class="table table-hover" :class="$classes['table-style']">
      <thead :class="$classes['customThead']">
        <tr>
          <th>
            <label class="form-checkbox">
              <input type="checkbox" v-if="visibleCheck" v-model="selectAll" @click="selectAllProductTable()">
              <i class="form-icon"></i>
            </label>
          </th>
          <th v-for="(t, key) in titles" :key="key" :value="t" :class="{
            [$classes['hidden-column']]: hiddenFields.includes(key)
          }">{{ t.title }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(obj, chave) in filteredData" :key="chave" :class="{
          [$classes['spaceUnder']]: true,
          [$classes['trfield-disabled']]: validateStock(obj.product_id),
          [$classes['success-low']]: getSuccessClass(obj) === 'success-low',
          [$classes['success-medium']]: getSuccessClass(obj) === 'success-medium',
          [$classes['success-high']]: getSuccessClass(obj) === 'success-high'
        }">
          <td>
            <label class="form-checkbox">
              <input type="checkbox" v-if="visibleCheck" :value="obj.product_id" v-model="selected"
                :disabled="validateStock(obj.product_id)">
              <i class="form-icon"></i>
            </label>
          </td>
          <td v-for="(item, chaveValor) in obj" :key="chaveValor" @click="selectedRow(obj)" :class="{
            [$classes['thfield-qtd']]: getClass(chaveValor),
            [$classes['hidden-column']]: hiddenFields.includes(chaveValor)
          }">
            <span v-if="item">{{ item }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style module>
.div-table {
  border-width: 1px;
  border-top-left-radius: 0.475rem;
  border-top-right-radius: 0.475rem;
  box-shadow: 0 5px 10px rgba(2, 2, 2, 0.25);
  background-color: white;
  max-height: calc(87vh - 230px);
  overflow-y: auto;
  overflow-x: auto;
  text-align: left;
  scrollbar-width: thin;
  scrollbar-color: #a2a2a2 transparent;
  width: 100%;
  box-sizing: border-box;
}

.div-table th {
  padding: 2.2em 1.5em;
}

.table-style {
  width: 100%;
  font-size: 14px;
  background-color: white;
}

thead.customThead {
  position: sticky;
  top: 0;
  height: 3.5rem;
  background: rgb(255, 254, 254);
  box-shadow: 0 3px 5px 0 rgba(2, 2, 2, 0.25);
  letter-spacing: 0.1rem;
  z-index: 10;
}

tr.spaceUnder>td {
  cursor: pointer;
  padding: 1.2em 1.5em;
  text-align: left;
}

.table-style input {
  width: 1.1rem;
  height: 1.1rem;
  text-decoration: none;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
}

.thfield-qtd {
  text-align: center !important;
}

.trfield-disabled {
  /* rgba(231,234,236,0.2); */
  background-color: #DBDBDB;
  color: #858585;
  pointer-events: none;
}

.success-low {
  border-left: 4px solid #dc3545;
}

.success-medium {
  border-left: 4px solid #ffc107;
}

.success-high {
  border-left: 4px solid #28a745;
}

/* Classe para ocultar colunas específicas */
.hidden-column {
  display: none !important;
}

/* Hover effects para as classes de sucesso */
.success-low:hover {
  background-color: rgba(220, 53, 69, 0.1);
  border-left-color: #c82333;
}

.success-medium:hover {
  background-color: rgba(255, 193, 7, 0.1);
  border-left-color: #e0a800;
}

.success-high:hover {
  background-color: rgba(40, 167, 69, 0.1);
  border-left-color: #1e7e34;
}

.input-label-invisible {
  visibility: hidden;
  text-overflow: ellipsis;
}

.div-table::-webkit-scrollbar {
  width: 4px;
}

.div-table::-webkit-scrollbar-track {
  background-color: transparent;
}

.div-table::-webkit-scrollbar-thumb {
  background-color: #a2a2a2;
  border-radius: 5px;
}

.div-table::-webkit-scrollbar-thumb:hover {
  background-color: #888;
}

@media (max-width: 1281px) {
  .div-table {
    overflow-x: auto;
  }
}
</style>
